import { render, staticRenderFns } from "./edit_liff.vue?vue&type=template&id=0f025c76&"
import script from "./edit_liff.vue?vue&type=script&lang=js&"
export * from "./edit_liff.vue?vue&type=script&lang=js&"
import style0 from "./edit_liff.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports